<mt-filter
    [filterConfig]="filterConfig"
    [progressBar]="filterConfig.isLoading"
    (filterChange)="search($event)"
></mt-filter>
<div class="report-container mt-4" *ngIf="reportStatus || systemError">
    <div class="header-container">
        <div class="header">
            <div class="float-left">
                <div class="title">
                    {{ "rpt_machine_status" | lang | uppercase }}
                </div>
            </div>
            <div class="float-right">
                <app-button-icon
                    [image]="'download'"
                    [iconType]="'icon'"
                    [disabled]="disabledExcelBtn"
                    [spinner]="btnSpinner"
                    (clickHandler)="downloadExcel()"
                ></app-button-icon>
            </div>
        </div>
    </div>

    <div [ngClass]="{ 'body-container': !hideReport || !systemError }">
        <!-- Message -->
        <div class="d-flex flex-row message" *ngIf="message">
            <img
                class="message-img"
                appImageSelector
                [imageType]="'icon'"
                [imageKey]="'error-red'"
                alt="error"
            />
            <span class="message-text">{{ message }}</span>
        </div>

        <app-system-error-message
            *ngIf="!!systemError"
            [message]="systemError"
        ></app-system-error-message>

        <div [hidden]="hideReport">
            <div class="row">
                <div class="col-6">
                    <app-pie-chart [data]="reportStatus"></app-pie-chart>
                </div>
                <div class="col-6">
                    <app-status-family-table
                        [data]="reportStatus"
                    ></app-status-family-table>
                </div>
            </div>
            <div class="row">
                <app-substate-table
                    [data]="reportStatus"
                    style="width: 100%; margin: 0 5px"
                ></app-substate-table>
            </div>
        </div>
    </div>
</div>
